import { unsubscribeEmail } from 'api';
import useAxios from 'hooks/useAxios';
import { IUnsubscribe } from '../../server/types';

const useUnsubscribeEmail = () => {
  const [request, { loading, error }] = useAxios<IUnsubscribe>();

  const handleUnsubscribe = async (email: string) => {
    const response = await request(unsubscribeEmail({ email }));

    return response;
  };

  return [handleUnsubscribe, { loading, error }] as const;
};

export { useUnsubscribeEmail };
